import type { Translation } from "./types";

const ar: Translation = {
    errors: {
        network: "خطأ في الاتصال، برجاء المحاولة مرة أخرى",
        tooLarge: "الملفات كبيرة جدًا على الرفع، برجاء تجربة ملفات أصغر",
        unknown: "حدث خطأ ما",
    },
    login: {
        title: "لوحة تحكم المسؤولين",
        subtitle: "أدخل رقم هاتفك للدخول إلى النظام",
        phonePlaceholder: "xxx xxx xxx",
        submitButton: "تسجيل الدخول",
    },
    verifyOtp: {
        title: "التحقق من الرمز",
        subtitle: "أدخل رمز التحقق المكون من 4 أرقام المرسل إلى هاتفك",
        resendLink: "إعادة إرسال الرمز",
        resendHint: "لم يصلك الرمز؟",
        submitButton: "تحقق",
        reEnterPhone: "إعادة إدخال رقم الهاتف",
    },
    contacts: {
        title: "طلبات التواصل",
        search: "ابحث بالاسم أو الإيميل أو الهاتف أو الرسالة",
        tabAll: "الكل",
        tabNew: "الجديدة",
        statTotal: "الإجمالي",
        statNew: "جديدة",
        statRead: "مقروءة",
        statReplied: "تم الرد",
        deleteWarning: "سيتم حذف طلبات التواصل المحددة نهائياً",
        noContact: "—",
        colEmail: "الإيميل",
        colPhone: "رقم الهاتف",
        view: "عرض الرسالة",
        repeats: "{count}×",
        repeatsHint: "اعرض كل الطلبات من جهة التواصل دي",
        filteredBy: "كل الطلبات من",
        clearChannel: "إلغاء الفلتر",
        copy: "نسخ",
        copied: "تم النسخ",
        colMessage: "الرسالة",
    },
    sideBar: {
        contacts: "التواصل",
        home: "الرئيسية",
        stores: "المتاجر",
        clients: "العملاء",
        coupons: "الكوبونات",
        subscriptions: "الاشتراكات",
        support: "الدعم",
        logs: "السجلات",
    },
    bottomBar: {
        more: "المزيد",
        close: "إغلاق",
    },
    profilePopup: {
        superAdmin: "مسؤول رئيسي",
        admin: "مسؤول",
        logout: "تسجيل الخروج",
        logoutConfirmMessage: "هل أنت متأكد من تسجيل الخروج؟",
        logoutConfirmAction: "تسجيل الخروج",
        logoutCancel: "إلغاء",
    },
    home: {
        title: "الرئيسية",
        greetingMorning: "صباح الخير",
        greetingAfternoon: "مساء الخير",
        greetingEvening: "مساء الخير",
        subtitle: "هذا هو وضع مينيوكت الآن",
        error: "تعذر تحميل النظرة العامة",
        retry: "إعادة المحاولة",
        rangeToday: "اليوم",
        range7d: "آخر ٧ أيام",
        range30d: "آخر ٣٠ يومًا",
        range90d: "آخر ٩٠ يومًا",
        range12m: "آخر ١٢ شهرًا",
        rangeAll: "كل الفترات",
        rangeCustom: "فترة مخصصة",
        periodAll: "كل الخطط",
        attentionTitle: "يحتاج إليك",
        attentionClear: "لا شيء ينتظرك",
        attentionTickets: "تذاكر مفتوحة",
        attentionPayments: "مدفوعات بانتظار التأكيد",
        attentionErrors: "أخطاء في السيرفر",
        attentionPaused: "متاجر موقوفة",
        storesTitle: "المتاجر",
        storesTotal: "إجمالي المتاجر",
        storesNew: "متاجر جديدة",
        storesSubscribed: "مشتركة",
        storesSubscribedHint: "لديها خطة سارية الآن",
        storesActive: "متاجر نشطة",
        storesPaused: "موقوفة",
        storesNeverPaid: "لم تشترك أبدًا",
        storesGrowth: "المتاجر الجديدة على مدار الوقت",
        storesByType: "حسب النوع",
        storesTopActive: "أكثر المتاجر نشاطًا",
        moneyTitle: "الأموال",
        revenue: "المحصّل",
        revenueHint: "بعد خصومات الكوبونات",
        gross: "بالسعر الأصلي",
        grossHint: "قبل أي خصم",
        discountGiven: "الخصومات الممنوحة",
        discountGivenHint: "ما خصمته الكوبونات",
        avgTicket: "متوسط البيع",
        pendingMoney: "بانتظار الدفع",
        pendingMoneyHint: "مطلوبة ولم تُحوّل بعد",
        subsPaid: "اشتراكات مدفوعة",
        subsPaidHint: "خطط وإضافات فروع",
        revenueOverTime: "الإيرادات على مدار الوقت",
        subsByStatus: "الطلبات حسب الحالة",
        subsByPeriod: "الإيرادات حسب الخطة",
        seriesRevenue: "المحصّل",
        seriesDiscount: "الخصم",
        couponsTitle: "الكوبونات",
        couponsTotal: "إجمالي الكوبونات",
        couponsActive: "فعّالة",
        couponsRedeemed: "مرات الاستخدام",
        couponsDiscounted: "ما تم التخلي عنه",
        supportTitle: "الدعم",
        ticketsOpen: "تذاكر مفتوحة",
        ticketsOpenHint: "الآن، أيًا كان وقت إنشائها",
        ticketsPending: "لم تُفتح",
        ticketsContacted: "جارٍ التعامل",
        ticketsTotal: "تذاكر مُنشأة",
        ticketsLatest: "الأطول انتظارًا",
        ticketsNone: "لا توجد تذاكر بلا رد",
        logsTitle: "حالة النظام",
        logsTotal: "الطلبات",
        logsErrorRate: "نسبة الأخطاء",
        logsErrors: "أخطاء",
        logsRejected: "مرفوضة",
        logsAvgResponse: "متوسط الاستجابة",
        logsTraffic: "حركة الطلبات",
        logsProblems: "الأعطال",
        logsCapped: "تُحفظ السجلات لفترة أقصر من الفترة المختارة",
        egp: "ج.م",
        viewAll: "عرض الكل",
        activityHint: "استخدموا اللوحة في هذه الفترة",
        noData: "لا يوجد شيء في هذه الفترة",
    },
    table: {
        retry: "إعادة المحاولة",
        empty: "لا يوجد شيء بعد",
        emptyHint: "جرّب بحثًا أو فلترًا مختلفًا",
        selectAll: "اختيار كل الصفوف",
        selectRow: "اختيار الصف",
        actions: "إجراءات",
        previous: "السابق",
        next: "التالي",
        back: "رجوع",
        filtersOpen: "الفلاتر",
        filtersClose: "إغلاق الفلاتر",
        filtersClear: "مسح",
        bulkTitle: "إجراءات جماعية",
        bulkSelected: "مُختار",
        bulkApply: "تطبيق",
        bulkDelete: "حذف",
        bulkClear: "إلغاء الاختيار",
        bulkOn: "نعم",
        bulkOff: "لا",
        preview: "فتح",
        deleteRow: "حذف",
        deleteTitle: "لا يمكن التراجع عن هذا. هل تريد الحذف؟",
        deleteCancel: "إلغاء",
        deleteConfirm: "حذف نهائي",
        countOf: "من",
        any: "الكل",
    },
    cols: {
        name: "الاسم",
        store: "المتجر",
        client: "العميل",
        status: "الحالة",
        period: "الخطة",
        price: "السعر",
        paid: "المدفوع",
        discount: "الخصم",
        code: "الكود",
        title: "العنوان",
        message: "الرسالة",
        phone: "رقم الهاتف",
        gender: "النوع",
        created: "تاريخ الإنشاء",
        updated: "آخر تحديث",
        endDate: "تاريخ الانتهاء",
        dueDate: "موعد الدفع",
        expiry: "تاريخ الانتهاء",
        uses: "مرات الاستخدام",
        maxUses: "الحد الأقصى",
        active: "مفعّل",
        owned: "يملك",
        access: "لديه صلاحية",
        method: "الطريقة",
        route: "المسار",
        severity: "الخطورة",
        outcome: "النتيجة",
        responseTime: "الزمن",
        surface: "الواجهة",
        model: "القسم",
        unlimited: "بلا حد",
        never: "أبدًا",
    },
    lists: {
        subscriptions: {
            statTotal: "إجمالي الاشتراكات",
            statActive: "فعّالة",
            statPending: "بانتظار الدفع",
            statRevenue: "المحصّل",
            tabAll: "الكل",
            tabPending: "بانتظار الدفع",
            tabActive: "الفعّالة",
            search: "ابحث باسم المتجر أو معرّفه",
            deleteWarning: "سيؤدي هذا إلى حذف صف الاشتراك وإعادة أي استخدام كوبون كان محجوزًا",
        },
        support: {
            statTotal: "إجمالي التذاكر",
            statPending: "لم تُفتح",
            statContacted: "جارٍ التعامل",
            statSolved: "تم حلها",
            tabAll: "الكل",
            tabOpen: "المفتوحة",
            tabSolved: "المحلولة",
            search: "ابحث بالعنوان أو الرسالة",
            deleteWarning: "سيؤدي هذا إلى حذف التذكرة للجميع، وليس للعميل فقط",
        },
        coupons: {
            statTotal: "إجمالي الكوبونات",
            statActive: "فعّالة",
            statRedeemed: "مرات الاستخدام",
            statDiscounted: "ما تم التخلي عنه",
            tabAll: "الكل",
            tabActive: "الفعّالة",
            tabInactive: "المعطّلة",
            search: "ابحث بالكود أو العنوان",
            deleteWarning: "الأكواد المستخدمة بالفعل يتم تجاهلها — يُحذف غير المستخدم فقط",
        },
        clients: {
            statTotal: "إجمالي العملاء",
            statOwners: "المالكون",
            tabAll: "الكل",
            search: "ابحث بالاسم أو رقم الهاتف",
            deleteWarning: "سيؤدي هذا إلى حذف الحساب وتذاكره. العميل الذي ما زال يملك متجرًا يتم تجاهله",
        },
        logs: {
            statTotal: "الطلبات",
            statErrors: "الأخطاء",
            statRejected: "المرفوضة",
            statAvg: "متوسط الاستجابة",
            tabAll: "الكل",
            tabErrors: "الأخطاء",
            search: "ابحث بالمسار أو الرابط أو الرسالة",
            deleteWarning: "تنتهي صلاحية السجلات تلقائيًا — الحذف يعجّل ذلك فقط",
        },
    },
    enums: {
        contactStatus: { new: "جديد", read: "مقروء", replied: "تم الرد" },
        storeType: {
            cafe: "كافيه",
            restaurant: "مطعم",
            both: "كافيه ومطعم",
            other: "أخرى",
        },
        subscriptionStatus: {
            pending: "قيد الانتظار",
            active: "نشط",
            coming: "قادم",
            grace: "فترة سماح",
            paused: "متوقف",
            canceled: "ملغي",
            ended: "منتهي",
        },
        subscriptionPeriod: {
            monthly: "شهري",
            quarterly: "ربع سنوي",
            annually: "سنوي",
        },
        logOutcome: {
            success: "ناجح",
            failed: "فاشل",
            unauthorized: "غير مصرح",
            forbidden: "ممنوع",
            notFound: "غير موجود",
            serverError: "خطأ في الخادم",
        },
        logSeverity: {
            success: "ناجح",
            rejected: "مرفوض",
            error: "عطل",
        },
        logSurface: {
            clients: "لوحة العملاء",
            admins: "لوحة المسؤولين",
            menu: "المنيو",
            website: "الموقع",
            webhooks: "الويب هوك",
            other: "أخرى",
        },
        logResponseBucket: {
            fast: "سريع (أقل من 300 مللي)",
            normal: "عادي (300 - 1000 مللي)",
            slow: "بطيء (1 - 3 ثوانٍ)",
            critical: "بطيء جدًا (أكثر من 3 ثوانٍ)",
        },
    },
    stores: {
        colName: "المتجر",
        colSlug: "المعرّف",
        colType: "النوع",
        colSubscription: "الاشتراك",
        colBranches: "الفروع",
        colProducts: "المنتجات",
        colCreated: "تاريخ الانضمام",
        tabAll: "الكل",
        tabSubscribed: "المشتركة",
        tabLapsed: "الموقوفة",
        statTotal: "إجمالي المتاجر",
        statSubscribed: "مشتركة",
        statPaused: "موقوفة",
        statPending: "بانتظار الدفع",
        statNoSub: "بلا اشتراك",
        deleteWarning: "سيؤدي هذا إلى حذف المتجر وكل فروعه ومنتجاته واشتراكاته وتذاكره",
        searchPlaceholder: "ابحث بالاسم أو المعرّف",
        filterAll: "الكل",
        filterNone: "بدون اشتراك",
        empty: "لا توجد متاجر",
        emptyHint: "جرّب بحثًا أو تصفية مختلفة",
        retry: "حاول مرة أخرى",
        branchesCount: "الفروع",
        productsCount: "المنتجات",
        noSubscription: "بدون اشتراك",
        results: "متجر",
        previous: "السابق",
        next: "التالي",
        page: "صفحة",
    },
    storeDetail: {
        back: "العودة إلى المتاجر",
        openMenu: "فتح المنيو",
        copyLink: "نسخ الرابط",
        copied: "تم النسخ",
        notFound: "المتجر غير موجود",
        retry: "حاول مرة أخرى",
        createdAt: "تاريخ الانضمام",
        sectionMenu: "المنيو",
        sectionBranches: "الفروع",
        sectionClients: "العملاء",
        sectionSubscription: "الاشتراك",
        sectionSupport: "الدعم",
        menuProducts: "المنتجات",
        menuActive: "نشطة",
        menuHidden: "مخفية",
        menuDiscounted: "عليها خصم",
        menuUnpriced: "بدون سعر",
        menuCategories: "الأقسام",
        branchesEmpty: "لا توجد فروع لهذا المتجر",
        branchInactive: "غير متاح",
        branchHidden: "مخفي",
        branchPrices: "تعديل سعر",
        clientsEmpty: "لا يوجد عملاء لهذا المتجر",
        owner: "مالك",
        staff: "موظف",
        allBranches: "كل الفروع",
        subNone: "لا يوجد اشتراك حالي لهذا المتجر",
        subPeriod: "المدة",
        subPrice: "السعر",
        subBranches: "عدد الفروع",
        subStartDate: "يبدأ",
        subEndDate: "ينتهي",
        subDaysLeft: "الأيام المتبقية",
        subPaymentDue: "آخر موعد للدفع",
        subCoupon: "الكوبون",
        subHistory: "السجل",
        subHistoryEmpty: "لا توجد اشتراكات سابقة",
        supportPending: "قيد الانتظار",
        supportContacted: "تم التواصل",
        supportSolved: "تم الحل",
        days: "يوم",
        currency: "ج.م",
        sectionActivity: "النشاط والأعطال",
        activityRequests: "إجمالي الطلبات",
        activityErrors: "الأعطال",
        activityRejected: "الطلبات المرفوضة",
        activityErrorRate: "نسبة الأعطال",
        activityAvgResponse: "متوسط زمن الاستجابة",
        activityPerDay: "الطلبات يوميًا",
        activityTopFailing: "أكثر الأخطاء تكرارًا",
        activityBySurface: "حسب الواجهة",
        activityEmpty: "لا يوجد نشاط مسجل لهذا المتجر في هذه الفترة",
        activityRange: "آخر {days} أيام",
        activityOpenLogs: "عرض كل السجلات",
        activityLastSeen: "آخر مرة",
    },
    logs: {
        searchPlaceholder: "ابحث بالمسار أو الرسالة",
        empty: "لا توجد سجلات",
        emptyHint: "جرّب توسيع الفترة الزمنية أو إزالة بعض الفلاتر",
        filters: "الفلاتر",
        clearFilters: "مسح الفلاتر",
        apply: "تطبيق",
        groupByHour: "بالساعة",
        groupByDay: "باليوم",
        totalRequests: "إجمالي الطلبات",
        errors: "أعطال",
        rejected: "مرفوضة",
        errorRate: "نسبة الأعطال",
        avgResponse: "متوسط الاستجابة",
        noErrors: "لا توجد أعطال في هذه الفترة 🎉",
        overTime: "الطلبات عبر الوقت",
        bySeverity: "حسب الخطورة",
        topFailing: "أكثر المسارات فشلًا",
        slowest: "أبطأ المسارات",
        topFailingStores: "المتاجر الأكثر تأثرًا",
        filterMethod: "نوع الطلب",
        filterSurface: "الواجهة",
        filterModel: "القسم",
        filterStatus: "كود الحالة",
        filterOutcome: "النتيجة",
        filterLang: "اللغة",
        filterResponseTime: "زمن الاستجابة",
        filterFrom: "من",
        filterTo: "إلى",
        any: "الكل",
        detailBack: "رجوع للسجلات",
        detailTitle: "تفاصيل السجل",
        detailNotFound: "السجل غير موجود",
        detailRequest: "الطلب",
        detailQuery: "الـ Query",
        detailBody: "الـ Body",
        detailResponse: "الرد",
        detailNoPayload: "لا يوجد محتوى محفوظ",
        detailTruncated: "تم اقتطاع جزء من المحتوى لكبر حجمه",
        detailStore: "المتجر",
        detailBranch: "الفرع",
        detailClient: "العميل",
        detailAdmin: "المسؤول",
        detailIp: "عنوان الـ IP",
        detailUserAgent: "المتصفح",
        detailLang: "اللغة",
        detailResponseTime: "زمن الاستجابة",
        detailAt: "الوقت",
        detailMessage: "الرسالة",
        retentionNote: "تُحفظ السجلات لمدة 10 أيام ثم تُحذف تلقائيًا",
    },
    subscriptions: {
        tabPlans: "الاشتراكات",
        tabAddons: "الفروع الإضافية",
        searchPlaceholder: "ابحث باسم المتجر أو المعرّف",
        filterAll: "الكل",
        empty: "لا يوجد شيء هنا",
        emptyHint: "جرّب تصفية مختلفة",
        retry: "حاول مرة أخرى",
        requested: "تاريخ الطلب",
        paymentDue: "آخر موعد للدفع",
        starts: "يبدأ",
        ends: "ينتهي",
        slots: "عدد الفروع",
        coupon: "الكوبون",
        was: "بدلاً من",
        activate: "مراجعة وتفعيل",
        cancel: "إلغاء الطلب",
        restore: "إعادة إلى قيد الانتظار",
        addonBranches: "فرع إضافي",
        addonActivate: "مراجعة وتفعيل",
        addonFor: "فوق",
        addonRequested: "تاريخ الطلب",
        addonActivated: "تاريخ التفعيل",
        addonFilterPending: "قيد الانتظار",
        addonFilterActivated: "مفعّلة",
        addonFilterRejected: "مرفوضة",
        confirmCancelMessage: "هل تريد إلغاء هذا الطلب؟ سيتم إرجاع استخدام الكوبون إن وُجد.",
        confirmCancelAction: "إلغاء الطلب",
        confirmRestoreMessage: "هل تريد إعادة هذا الطلب إلى قيد الانتظار؟ سيتم خصم استخدام الكوبون مرة أخرى.",
        confirmRestoreAction: "إعادة",
        keep: "تراجع",
    },
    activatePopup: {
        title: "تأكيد الدفع",
        expected: "المبلغ المتوقع",
        amountLabel: "المبلغ المستلم",
        mismatch: "هذا المبلغ لا يطابق المبلغ المتوقع",
        confirm: "تفعيل",
        cancel: "إلغاء",
        queuedWarning: "هذا المتجر لديه اشتراك نشط بالفعل، لذا سيتم وضع هذا الطلب في الانتظار كاشتراك قادم بدلاً من تفعيله الآن.",
    },
    support: {
        searchPlaceholder: "ابحث في التذاكر",
        filterOpen: "المفتوحة",
        filterAll: "الكل",
        filterPending: "قيد الانتظار",
        filterContacted: "تم التواصل",
        filterSolved: "تم الحل",
        filterDeleted: "المحذوفة",
        empty: "لا توجد تذاكر",
        emptyHint: "جرّب تصفية مختلفة",
        markPending: "وضع قيد الانتظار",
        markContacted: "تم التواصل",
        markSolved: "تم الحل",
        openedBy: "فتحها",
        at: "في",
    },
    coupons: {
        searchPlaceholder: "ابحث بالكود أو العنوان",
        filterAll: "الكل",
        filterActive: "مفعّلة",
        filterInactive: "معطّلة",
        empty: "لا توجد كوبونات",
        emptyHint: "أنشئ واحدًا للبدء",
        create: "كوبون جديد",
        edit: "تعديل",
        toggleOn: "تفعيل",
        toggleOff: "تعطيل",
        delete: "حذف",
        usage: "الاستخدام",
        redeemed: "مرات الاستخدام",
        discounted: "إجمالي الخصم",
        uses: "استخدام",
        unlimited: "غير محدود",
        expires: "ينتهي في",
        neverExpires: "بدون انتهاء",
        reusable: "يمكن للمتجر استخدامه أكثر من مرة",
        oncePerStore: "مرة واحدة لكل متجر",
        off: "خصم",
        confirmDeleteMessage: "هل تريد حذف هذا الكوبون؟ لا يمكن التراجع.",
        confirmDeleteAction: "حذف",
        keep: "تراجع",
        formTitle: "العنوان",
        formCode: "الكود",
        formDiscountType: "نوع الخصم",
        formPercentage: "نسبة مئوية",
        formFixed: "مبلغ ثابت",
        formDiscountAmount: "قيمة الخصم",
        formTypes: "يصلح لـ",
        formPeriods: "يغطي الباقات",
        formMaxUses: "الحد الأقصى للاستخدام (اتركه فارغًا = غير محدود)",
        formExpiresAt: "تاريخ الانتهاء (اتركه فارغًا = بدون انتهاء)",
        formAllowReuse: "يمكن للمتجر نفسه استخدامه مرة أخرى",
        formIsActive: "مفعّل",
        formSave: "حفظ",
        formCancel: "إلغاء",
        actionNew: "اشتراك جديد",
        actionRenew: "تجديد",
        actionBranch: "فروع إضافية",
        usageEmpty: "لم يُستخدم هذا الكوبون بعد",
        usagePaid: "مدفوع",
        usageWaiting: "محجوز",
        usageReleased: "مُعاد",
        usageKindSubscription: "اشتراك",
        usageKindAddon: "فروع إضافية",
    },
    clients: {
        searchPlaceholder: "ابحث بالاسم أو رقم الهاتف",
        empty: "لا يوجد عملاء",
        emptyHint: "جرّب بحثًا مختلفًا",
        owns: "يملك",
        worksAt: "يعمل في",
        stores: "متجر",
        back: "العودة إلى العملاء",
        notFound: "العميل غير موجود",
        ownedStores: "المتاجر المملوكة",
        accessStores: "الصلاحيات الممنوحة",
        noStores: "لا توجد متاجر",
        supportTickets: "تذاكر الدعم",
        joined: "تاريخ الانضمام",
        edit: "تعديل البيانات",
        formName: "الاسم",
        formGender: "النوع",
        genderMale: "ذكر",
        genderFemale: "أنثى",
        genderUnset: "غير محدد",
        formSave: "حفظ",
        formCancel: "إلغاء",
        allBranches: "كل الفروع",
    },
    notFound: {
        title: "الصفحة غير موجودة",
        subtitle: "الصفحة التي تبحث عنها غير موجودة",
        backButton: "العودة إلى الرئيسية",
    },
};

export default ar;
